import React, { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid2'
import Faqs from 'components/FaqsPage/Faqs'
import EasyButton from 'components/Easy/EasyButton'
import EasyWhatsappLink from 'components/Easy/EasyWhatsappLink/EasyWhatsappLink'
import sx from './styles'

const EasyFaqs = (props) => {
  const {
    items = [],
    subtitle = 'EASY_FAQS_SUBTITLE',
    isEasyAgencias = false,
    onClickButton,
    onClickWhatsappButton,
    showWhatsappButton = false,
  } = props

  return (
    <Grid
      id="Preguntasfrecuentes"
      container
      sx={sx.root}
    >
      <Grid
        container
        size={12}
        sx={sx.title}
        justifyContent="center"
      >
        <Typography
          component="h2"
          align="center"
          variant="h1"
        >
          <FormattedMessage
            id="EASY_FAQS_TITLE"
          />
        </Typography>
        <Typography
          component="h3"
          sx={sx.subtitle}
          align="center"
          variant="h2"
        >
          <FormattedMessage id={subtitle} />
        </Typography>
      </Grid>

      <Grid
        size={12}
        mt={6}
      >
        <Faqs
          variant="row"
          data={items}
        />
      </Grid>

      <Grid
        size={12}
        mt={4}
        sx={sx.cts}
      >
        <EasyButton
          showIcon={!isEasyAgencias}
          cta={isEasyAgencias ? 'EASY_IM_INTERESTED' : 'EASY_MAIN_CTA'}
          handleClick={onClickButton}
        />
        {showWhatsappButton && (
          <EasyWhatsappLink onClickWhatsapp={onClickWhatsappButton} />
        )}

      </Grid>
    </Grid>
  )
}

export default memo(EasyFaqs)
